import { useEffect } from "react";

const DESKTOP_MEDIA = "(min-width: 992px)";

const getDesktopMedia = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null;
  }
  const media = window.matchMedia(DESKTOP_MEDIA);
  return media && typeof media.matches === "boolean" ? media : null;
};

const isDesktopViewport = () => {
  const media = getDesktopMedia();
  return media ? media.matches : true;
};

/**
 * Locks body scroll on desktop split auth pages; allows scroll on tablet/mobile stacks.
 */
export const useAuthPageBodyLock = () => {
  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    const media = getDesktopMedia();

    const apply = () => {
      const lockScroll = isDesktopViewport();
      document.body.style.overflow = lockScroll ? "hidden" : previousBodyOverflow || "";
      document.documentElement.style.overflow = lockScroll ? "hidden" : previousHtmlOverflow || "";
    };

    apply();
    if (media) {
      media.addEventListener("change", apply);
    }

    return () => {
      if (media) {
        media.removeEventListener("change", apply);
      }
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, []);
};
